export default __webpack_public_path__ + "static/media/outlook.ea2d1445.svg";